// extracted by mini-css-extract-plugin
module.exports = {"footer":"DeleteNftCollectionModal_footer__2i0ot","text":"DeleteNftCollectionModal_text__3TVF1"};